import React from 'react';
import { Input } from 'antd';

const columns = (updateValue: (value: any, record: any, key: string) => void) => {
    return [
        {
            title: 'Milestone Day',
            dataIndex: 'milestoneDay',
        },
        {
            title: 'Bonus Coins',
            dataIndex: 'bonusCoins',
            render: (val: any, record: any) => {
                return (
                    <Input
                        value={val}
                        onChange={(e) => updateValue(parseFloat(e.target.value), record, 'bonusCoins')}
                        style={{ width: '100px', textAlign: 'center', borderRadius: '5px' }}
                    />
                );
            },
        },
        {
            title: 'Bonus Points',
            dataIndex: 'bonusPoints',
            render: (val: any, record: any) => {
                return (
                    <Input
                        value={val}
                        onChange={(e) => updateValue(parseFloat(e.target.value), record, 'bonusPoints')}
                        style={{ width: '100px', textAlign: 'center', borderRadius: '5px' }}
                    />
                );
            },
        },
    ];
};

export { columns };
